import { formatPhoneNumber } from 'lib/numUtils.js';

export const getPhoneComposerToOptions = (contacts = [], detailTypes = {}) => {
  return (contacts || []).reduce((all, contact, index) => {
    contact.details.forEach((item) => {
      let type = detailTypes[item.detail_type_id];
      if (type && type.type === 'phone') {
        let dropDownValue = `${contact.first_name} ${contact.last_name} - ${formatPhoneNumber(item.value)}`;
        if (item.detail_subtype) {
          dropDownValue = `${contact.first_name} ${contact.last_name} - ${formatPhoneNumber(item.value)} - ${item.detail_subtype}`;
        }
        all.push({
          ...contact,
          detailsData: { ...item },
          dropdownValue: dropDownValue,
          dropdownId: item.id,
        });
      }
    });
    return all;
  }, []);
};
